import customersPage from "./customers.component";
import customersUrls from "./customers.urls";
import customersTransforms from "./customers.transforms";

const customerModule = angular
  .module("app.pages.customers", [])
  .component("customersPage", customersPage)
  .service("CustomersTransforms", customersTransforms)
  .config(customersUrls);

export default customerModule;



// WEBPACK FOOTER //
// ./src/pages/customers/customers.module.js